import { useContext } from 'react'
import { AppBar, IconButton } from '@mui/material'
import { CloseIcon } from '$common/icons/close'
import { BackButton } from '$common/buttons'
import { CircularLoading } from '$common/loading/circular-loading'
import { t } from '$i18n'
import { DirectionContext } from '$setup/root'
import { PageToolbar } from '$common/app-bar/common/page-toolbar'
import { AppBarSearchInput } from '$common/input/app-bar-search-input'

interface Prop {
  onBack: () => unknown
  setQuery: (query: string) => void
  loading?: boolean
  value: string
  height?: number
  backgroundColor?: string
}

export function AppBarBackSearch({
  onBack,
  setQuery,
  loading,
  value,
  height,
  backgroundColor,
}: Prop) {
  const direction = useContext(DirectionContext)

  return (
    <AppBar sx={{ maxWidth: 'none', margin: 0, backgroundColor }}>
      <PageToolbar sx={{ height }} backgroundColor={backgroundColor}>
        <BackButton onClick={onBack} color="inherit" />

        <AppBarSearchInput
          dir={direction}
          fullWidth
          autoFocus
          placeholder={t('common.search')}
          value={value}
          onChange={e => setQuery(e.target.value)}
          backgroundColor={backgroundColor}
        />

        {value &&
          (loading ? (
            <CircularLoading size={20} color="inherit" />
          ) : (
            <IconButton onClick={() => setQuery('')}>
              <CloseIcon sx={{ color: 'inherit' }} />
            </IconButton>
          ))}
      </PageToolbar>
    </AppBar>
  )
}
AppBarBackSearch.defaultProps = {
  loading: false,
}
